const IconReduceButton = ({ onClick, style }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={style}
    >
      <g id="Reduce">
        <rect
          id="Rectangle 1361"
          x="0.5"
          y="0.500488"
          width="39"
          height="39"
          rx="11.5"
          fill="white"
          stroke="#D9D9D9"
        />
        <path
          id="Line 351"
          d="M12 20.0005H28"
          stroke="#E13B30"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export default IconReduceButton;
